(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-blocks"]) return;
  try {
    
  class AppBlocksNear extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;
      const open = () => {
        if (this.near) this.near.disconnect();
        this.near = null;
        // The apps the head holds back define what the blocks call, so the blocks wait for them.
        if (typeof window.appsLater === 'function') window.appsLater(() => this.build(template));
        else this.build(template);
      };
      if (!('IntersectionObserver' in window)) return open();
      this.near = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) open();
      }, { rootMargin: '800px 0px' });
      this.near.observe(this);
    }

    disconnectedCallback() {
      if (this.near) this.near.disconnect();
    }

    // Inserted scripts would all start at once; here each runs in page order, a file loaded before the script after it, as a block written after load expects.
    async build(template) {
      if (!this.isConnected) return;
      const fragment = document.importNode(template.content, true);
      const types = new Map();
      for (const script of fragment.querySelectorAll('script')) {
        const type = script.getAttribute('type');
        if (!/^(|text\/javascript|application\/javascript|module)$/i.test((type || '').trim())) continue;
        types.set(script, type);
        script.setAttribute('type', 'javascript/held');
      }
      this.replaceWith(fragment);
      for (const [script, type] of types) {
        const fresh = document.createElement('script');
        for (const attribute of script.attributes) {
          if (attribute.name !== 'type') fresh.setAttribute(attribute.name, attribute.value);
        }
        if (type !== null) fresh.setAttribute('type', type);
        if (!script.hasAttribute('src')) {
          fresh.text = script.text;
          script.replaceWith(fresh);
          continue;
        }
        fresh.async = false;
        const done = new Promise((settle) => {
          fresh.addEventListener('load', settle);
          fresh.addEventListener('error', settle);
        });
        script.replaceWith(fresh);
        if (!script.hasAttribute('async')) await done;
      }
    }
  }

  customElements.define('app-blocks-near', AppBlocksNear);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      // A line the customer put into the cart opens the drawer; a gift the rewards add on their own must not.
      document.addEventListener('cart:updated', (event) => {
        if (event.detail.added && event.detail.source !== 'cart-rewards') this.open();
      });
      document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-cart-open]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || !window.theme) return;
        event.preventDefault();
        this.open();
        window.theme.cart.refresh().catch(() => {});
      });
      // A ported section asks for the drawer with this event; show() never sends it back.
      document.addEventListener('theme:cart:open', () => this.show());
    }

    show() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      // Recommendations are asked for only once someone looks at the cart, never with the page.
      for (const upsell of this.querySelectorAll('cart-upsell')) upsell.load?.();
    }

    open() {
      const closed = !this.dialog.open;
      this.show();
      if (closed) document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true, detail: { origin: 'core' } }));
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-submit-on-change]')) event.target.form.submit();
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // On a phone the link columns fold like live; from the width of a tablet on they stand open and cannot be folded.
  const narrowFooter = window.matchMedia('(max-width: 767px)');
  const footerFolds = () => {
    for (const fold of document.querySelectorAll('.site-footer__fold')) {
      fold.open = !narrowFooter.matches;
      fold.querySelector('summary').tabIndex = narrowFooter.matches ? 0 : -1;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', footerFolds);
  else footerFolds();
  narrowFooter.addEventListener('change', footerFolds);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.site-footer__summary') && !narrowFooter.matches) event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      // The header sticks to the top: what else sticks (the product gallery) stands below it, at the height it has now.
      // A bar that sticks above it (data-header-above, the purchase lock) pushes it down by its own height, and what
      // sticks below the header below both.
      const above = document.querySelector('[data-header-above]');
      const measure = () => {
        const offset = above ? Math.round(above.getBoundingClientRect().height) : 0;
        if (above) document.documentElement.style.setProperty('--header-offset', `${offset}px`);
        document.documentElement.style.setProperty('--header-height', `${Math.round(this.getBoundingClientRect().height) + offset}px`);
      };
      measure();
      if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(measure);
        observer.observe(this);
        if (above) observer.observe(above);
      }
      this.drawer = this.querySelector('dialog');
      this.megas = [...this.querySelectorAll('[data-mega]')];
      this.desktop = window.matchMedia('(min-width: 1024px) and (hover: hover)');

      const burger = this.querySelector('[data-drawer-open]');
      burger.addEventListener('click', () => {
        this.drawer.showModal();
        burger.setAttribute('aria-expanded', 'true');
      });
      this.querySelector('[data-drawer-close]').addEventListener('click', () => this.drawer.close());
      this.drawer.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.drawer.close();
      });
      this.drawer.addEventListener('close', () => burger.setAttribute('aria-expanded', 'false'));

      for (const mega of this.megas) {
        mega.addEventListener('toggle', () => {
          mega.querySelector('summary').setAttribute('aria-expanded', String(mega.open));
          if (mega.open) this.closeMegas(mega);
        });
        mega.querySelector('summary').addEventListener('click', (event) => {
          // A mouse click right after hover-open would close the panel again; keyboard clicks carry detail 0.
          if (this.desktop.matches && mega.open && event.detail > 0) event.preventDefault();
        });
      }
      for (const item of this.querySelectorAll('[data-nav-list] > li')) {
        item.addEventListener('mouseenter', () => {
          if (!this.desktop.matches) return;
          const mega = item.querySelector('[data-mega]');
          // Without the delay a panel opens on the way to the entry next to it.
          this.hover = setTimeout(() => {
            this.closeMegas(mega);
            if (mega) mega.open = true;
          }, this.megas.some((open) => open.open) ? 0 : 140);
        });
        item.addEventListener('mouseleave', () => clearTimeout(this.hover));
      }
      this.addEventListener('mouseleave', () => {
        clearTimeout(this.hover);
        if (this.desktop.matches) this.closeMegas();
      });
      for (const type of ['click', 'focusin']) {
        document.addEventListener(type, (event) => {
          if (!this.contains(event.target)) this.closeMegas();
        });
      }
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = this.megas.find((mega) => mega.open);
        if (open) {
          open.open = false;
          open.querySelector('summary').focus();
        }
        this.closeSearch();
      });

      this.search = this.querySelector('#site-search');
      this.searchToggle = this.querySelector('[data-search-open]');
      this.searchToggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeMegas();
        this.search.hidden = false;
        this.searchToggle.setAttribute('aria-expanded', 'true');
        this.search.querySelector('input').focus();
      });
      this.querySelector('[data-search-close]').addEventListener('click', () => this.closeSearch());
    }

    closeMegas(except) {
      for (const mega of this.megas) {
        if (mega !== except) mega.open = false;
      }
    }

    closeSearch() {
      if (this.search.hidden) return;
      this.search.hidden = true;
      this.searchToggle.setAttribute('aria-expanded', 'false');
      this.searchToggle.focus();
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-elektrolyte-neu"] && !Shopify.designMode) return;
  try {
    
  /* Test elektrolyte-pdp-2026-10: in den neuen Armen startet die Paketwahl auf dem Hausapotheke-Paket (wie im Entwurf), und die
     Knöpfe des Abschlusses wählen ihr Paket oben und legen es über die Paketwahl in den Warenkorb. */
  (function () {
    var key = 'data-exp-elektrolyte-pdp-2026-10';
    function arm() { return document.documentElement.getAttribute(key) || ''; }
    function picker() { return document.querySelector('.product__info package-picker'); }
    function inputs() { var p = picker(); return p ? Array.prototype.slice.call(p.querySelectorAll('[data-package-option] input')) : []; }
    function choose(n) {
      var list = inputs(); var input = list[n - 1];
      if (!input) return null;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return input;
    }
    function money(cents) {
      var p = picker();
      return window.theme && window.theme.formatMoney ? window.theme.formatMoney(cents, p ? p.dataset.moneyFormat : undefined) : (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    function prices() {
      inputs().forEach(function (input, i) {
        document.querySelectorAll('[data-hhx-price="' + (i + 1) + '"]').forEach(function (el) { el.textContent = money(Number(input.dataset.price)); });
      });
    }
    function start() {
      var a = arm();
      if (a !== 'v1' && a !== 'v2') return;
      if (!sessionStorage.getItem('hhx-picked')) choose(3);
      inputs().forEach(function (input) { input.addEventListener('change', function (e) { if (e.isTrusted) try { sessionStorage.setItem('hhx-picked', '1'); } catch (x) {} }); });
      prices();
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hhx-buy]');
        if (!b) return;
        e.preventDefault();
        if (!choose(Number(b.getAttribute('data-hhx-buy')))) return;
        var cta = picker() && picker().querySelector('[data-cta]');
        if (cta) cta.click();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class ArticleContents extends HTMLElement {
    connectedCallback() {
      // Liquid allein entscheidet, ob das Verzeichnis steht: was nach dem Laden erscheint, verschiebt den Text.
      const list = this.querySelector('[data-contents-list]');
      if (this.hidden || !list) return;
      const headings = [...list.querySelectorAll('a')].map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.find((entry) => entry.isIntersecting);
          if (!visible) return;
          for (const link of list.querySelectorAll('a')) {
            if (link.hash === `#${visible.target.id}`) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          }
        },
        { rootMargin: '0px 0px -70% 0px' },
      );
      headings.forEach((heading) => observer.observe(heading));
    }
  }

  customElements.define('article-contents', ArticleContents);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-offer-checkout"]) return;
  try {
    
  const OFFER_KEY = /^[a-z0-9]+(-[a-z0-9]+)*$/;
  const OFFER_ITEMS = /^(\d{1,20}:\d{1,2},){1,20}$/;
  const DISCOUNT_CODE = /^[A-Za-z0-9_-]{1,64}$/;

  class OfferCheckout extends HTMLElement {
    connectedCallback() {
      // The lines take their marker from theme.js, which is deferred too; whichever script runs first, both are there once the document is parsed.
      if (window.theme) this.run(window.location.search);
      else document.addEventListener('DOMContentLoaded', () => this.run(window.location.search), { once: true });
    }

    // Only an offer Liquid has rendered from the metafield counts; the address names it, it never describes it.
    plan(search) {
      const params = new URLSearchParams(search);
      const key = params.get('offer') ?? '';
      const code = params.get('code') ?? '';
      if (!OFFER_KEY.test(key) || key.length > 100 || (code !== '' && !DISCOUNT_CODE.test(code))) return null;
      const offer = [...this.querySelectorAll('[data-offer]')].find((element) => element.dataset.offer === key);
      const listed = offer?.dataset.offerItems ?? '';
      if (!OFFER_ITEMS.test(listed)) return null;
      const items = listed.split(',').filter(Boolean).map((entry) => {
        const [id, quantity] = entry.split(':');
        return { id: Number(id), quantity: Number(quantity), properties: window.theme.markers({ offer: key }) };
      });
      if (items.some((item) => !Number.isSafeInteger(item.id) || item.id < 1 || item.quantity < 1)) return null;
      // Attribution parameters travel on byte for byte, so whoever reads them at the checkout sees what the landing page sent.
      const attribution = search.replace(/^\?/, '').split('&').filter((part) => part.startsWith('tf_'));
      const checkout = attribution.length === 0 ? '/checkout' : `/checkout?${attribution.join('&')}`;
      return { key, items, target: code === '' ? checkout : `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(checkout)}` };
    }

    async post(url, body) {
      const response = await fetch(`${url}.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!response.ok) throw new Error(String(response.status));
    }

    async run(search) {
      const status = this.querySelector('[data-offer-status]');
      const plan = this.plan(search);
      if (plan === null) return this.fail(status);
      status.hidden = false;
      try {
        // An offer is a closed purchase: the cart is emptied first, the attribute goes in last so the discount function sees all of it.
        await this.post(this.dataset.clearUrl, {});
        await this.post(this.dataset.addUrl, { items: plan.items });
        await this.post(this.dataset.updateUrl, { attributes: window.theme.attributes({ offer: plan.key }) });
      } catch {
        return this.fail(status);
      }
      window.location.replace(plan.target);
    }

    fail(status) {
      status.hidden = true;
      this.querySelector('[data-offer-failed]').hidden = false;
    }
  }

  customElements.define('offer-checkout', OfferCheckout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dialog = this.querySelector('[data-dialog]');
      this.strip = this.querySelector('.product-gallery__thumbnails');
      this.arrows = [...this.querySelectorAll(':scope > [data-gallery-step]')];
      this.addEventListener('click', (event) => this.onClick(event));
      this.track.addEventListener('keydown', (event) => this.onKey(event));
      this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => this.mark()), { passive: true });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.dialog.querySelector('[data-zoomed]').replaceChildren());
      this.onVariant = ({ detail }) => this.show(detail.mediaId);
      document.addEventListener('variant:changed', this.onVariant);
      this.onWake = () => this.wake();
      if (document.readyState === 'complete') this.wake();
      else for (const type of ProductGallery.WAKE) window.addEventListener(type, this.onWake, { passive: true });
      // The arrows sit on the middle of the pictures, not of the gallery with its strip.
      if (this.arrows.length > 0 && typeof ResizeObserver === 'function') {
        this.resizer = new ResizeObserver(() => this.style.setProperty('--gallery-arrow-top', `${this.track.offsetTop + this.track.offsetHeight / 2}px`));
        this.resizer.observe(this.track);
      }
      this.mark();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
      for (const type of ProductGallery.WAKE) window.removeEventListener(type, this.onWake, { passive: true });
      this.resizer?.disconnect();
    }

    static WAKE = ['load', 'pointerdown', 'pointermove', 'keydown', 'scroll', 'wheel', 'touchstart'];

    // Where a row of pictures stands: the picture filling it.
    static at(track) {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    static go(track, step) {
      const target = track.children[ProductGallery.at(track) + step];
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft });
    }

    wake() {
      if (this.awake) return;
      this.awake = true;
      this.setAttribute('data-gallery-awake', '');
      for (const type of ProductGallery.WAKE) window.removeEventListener(type, this.onWake, { passive: true });
      window.requestAnimationFrame(() => this.previewSlides());
    }

    // A slide has no picture of its own: its thumbnail is a copy of the rendered slide at the width of the track, scaled to the
    // thumbnail, so a stencil looks there as it does above. A slide that rendered nothing loses its place.
    previewSlides() {
      const stages = [...this.querySelectorAll('[data-thumb-stage]')];
      if (stages.length === 0) return;
      for (const stage of stages) {
        const link = stage.closest('[data-thumbnail]');
        const item = this.items.find((entry) => entry.dataset.mediaId === link.dataset.thumbnail);
        if (!item) {
          link.closest('li')?.remove();
          continue;
        }
        const copy = item.cloneNode(true);
        copy.removeAttribute('id');
        for (const node of copy.querySelectorAll('[id]')) node.removeAttribute('id');
        for (const node of copy.querySelectorAll('a, button, input, [tabindex]')) node.setAttribute('tabindex', '-1');
        stage.replaceChildren(copy);
      }
      const scale = () => {
        const width = this.track.clientWidth;
        const thumb = stages[0].parentElement.clientWidth;
        if (width === 0 || thumb === 0) return;
        this.strip.style.setProperty('--gallery-stage', `${width}px`);
        this.strip.style.setProperty('--gallery-thumb-scale', String(thumb / width));
      };
      scale();
      if (typeof ResizeObserver === 'function') new ResizeObserver(scale).observe(this.track);
    }

    get items() {
      return [...this.track.children];
    }

    get index() {
      return ProductGallery.at(this.track);
    }

    onClick(event) {
      const thumbnail = event.target.closest('[data-thumbnail]');
      const zoom = event.target.closest('[data-zoom]');
      const step = event.target.closest('[data-gallery-step]');
      if (thumbnail) {
        event.preventDefault();
        this.show(thumbnail.dataset.thumbnail);
      } else if (step && this.arrows.includes(step)) {
        this.step(Number(step.dataset.galleryStep));
      } else if (zoom && this.track.contains(zoom) && typeof this.dialog.showModal === 'function') {
        event.preventDefault();
        this.zoom(this.items.indexOf(zoom.closest('.product-gallery__item')));
      }
    }

    onKey(event) {
      const step = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
      if (!step || !this.items[this.index + step]) return;
      event.preventDefault();
      this.step(step);
    }

    step(step) {
      const target = this.items[this.index + step];
      if (target) this.show(target.dataset.mediaId);
    }

    show(mediaId) {
      this.wake();
      const item = this.items.find((entry) => entry.dataset.mediaId === String(mediaId));
      if (item) this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft });
    }

    mark() {
      const index = this.index;
      const current = this.items[index]?.dataset.mediaId;
      for (const thumbnail of this.querySelectorAll('[data-thumbnail]')) {
        if (thumbnail.dataset.thumbnail === current) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      }
      for (const arrow of this.arrows) {
        const step = Number(arrow.dataset.galleryStep);
        arrow.hidden = !this.items[index + step];
      }
      // The strip follows the picture, so the current thumbnail never stands cut off at its edge.
      const active = this.strip?.querySelector('[aria-current="true"]')?.closest('li');
      if (active) {
        const left = active.offsetLeft - this.strip.offsetLeft;
        if (left < this.strip.scrollLeft || left + active.offsetWidth > this.strip.scrollLeft + this.strip.clientWidth) {
          this.strip.scrollTo({ left: left - (this.strip.clientWidth - active.offsetWidth) / 2 });
        }
      }
    }

    // The enlarged view holds a copy of every picture and slide, each in a square that fits the window; a slide keeps its
    // classes on the square, so the brand's slide styles and its fitting script (event gallery:zoom) still reach it.
    zoom(start) {
      const view = this.dialog.querySelector('[data-zoomed]');
      const row = document.createElement('ul');
      row.className = 'product-gallery__zoom-track';
      row.setAttribute('role', 'list');
      for (const item of this.items) {
        const entry = document.createElement('li');
        entry.className = 'product-gallery__zoom-item';
        const square = document.createElement('div');
        square.className = [...item.classList].filter((name) => name !== 'product-gallery__item').concat('product-gallery__zoom-square').join(' ');
        for (const [name, value] of Object.entries(item.dataset)) if (name !== 'mediaId') square.dataset[name] = value;
        for (const child of item.childNodes) square.appendChild(child.cloneNode(true));
        for (const node of square.querySelectorAll('[id]')) node.removeAttribute('id');
        for (const image of square.querySelectorAll('img')) {
          image.loading = 'eager';
          image.sizes = '(min-width: 750px) 88vh, 100vw';
        }
        for (const link of square.querySelectorAll('[data-zoom]')) {
          link.removeAttribute('data-zoom');
          link.removeAttribute('href');
        }
        entry.appendChild(square);
        row.appendChild(entry);
      }
      const parts = [row];
      if (row.children.length > 1) {
        for (const [step, label] of [[-1, this.dialog.dataset.labelPrevious], [1, this.dialog.dataset.labelNext]]) {
          const arrow = this.arrows.find((button) => Number(button.dataset.galleryStep) === step)?.cloneNode(true) ?? ProductGallery.arrow(step, label);
          arrow.addEventListener('click', () => ProductGallery.go(row, step));
          parts.push(arrow);
        }
        const mark = () => {
          for (const arrow of parts.slice(1)) arrow.hidden = !row.children[ProductGallery.at(row) + Number(arrow.dataset.galleryStep)];
        };
        row.addEventListener('scroll', () => window.requestAnimationFrame(mark), { passive: true });
        window.requestAnimationFrame(mark);
      }
      view.replaceChildren(...parts);
      this.dialog.showModal();
      const target = row.children[start];
      if (target) row.scrollTo({ left: target.offsetLeft - row.offsetLeft, behavior: 'instant' });
      const onKey = (event) => {
        const step = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
        if (!step) return;
        event.preventDefault();
        ProductGallery.go(row, step);
      };
      this.dialog.addEventListener('keydown', onKey);
      this.dialog.addEventListener('close', () => this.dialog.removeEventListener('keydown', onKey), { once: true });
      window.theme?.emit?.('gallery:zoom', { dialog: this.dialog });
    }

    static arrow(step, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `icon-button product-gallery__arrow product-gallery__arrow--${step < 0 ? 'previous' : 'next'}`;
      button.dataset.galleryStep = String(step);
      button.setAttribute('aria-label', label ?? '');
      button.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      return button;
    }
  }

  class ProductChoice extends HTMLElement {
    // The quantity is a number field, or the checked pack radio; with a value, the pack radio that carries it.
    static quantityField(live, value) {
      const packs = [...live.querySelectorAll('input[type="radio"][name="quantity"]')];
      if (packs.length === 0) return live.querySelector('input[name="quantity"]');
      return packs.find((pack) => (value === undefined ? pack.checked : pack.value === value)) ?? null;
    }

    connectedCallback() {
      for (const button of this.querySelectorAll('[data-apply]')) button.hidden = true;
      this.addEventListener('change', (event) => this.select(event.target));
    }

    async select(input) {
      const live = this.closest('[data-product-live]');
      const form = input.form;
      if (!live) {
        form.submit();
        return;
      }
      const params = new URLSearchParams(new FormData(form));
      ProductChoice.pending?.abort();
      ProductChoice.pending = new AbortController();
      try {
        const response = await fetch(`${form.action}?${params}&section_id=${live.dataset.sectionId}`, { signal: ProductChoice.pending.signal });
        if (!response.ok) throw new Error(response.statusText);
        const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-product-live]');
        if (!next) throw new Error('section without product');

        const quantity = ProductChoice.quantityField(live)?.value;
        const variantChanged = live.dataset.variantId !== next.dataset.variantId;
        live.replaceChildren(...next.children);
        Object.assign(live.dataset, { variantId: next.dataset.variantId, mediaId: next.dataset.mediaId });
        const field = ProductChoice.quantityField(live, quantity);
        if (field?.type === 'radio') {
          field.checked = true;
          // The rows of the packs name the chosen pack in their panels; the fresh markup names the preselected one.
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
        else if (field && quantity) {
          field.value = quantity;
          field.dispatchEvent(new Event('change'));
        }
        document.getElementById(input.id)?.focus();

        const url = new URL(window.location.href);
        for (const name of ['variant', 'selling_plan']) {
          if (params.get(name)) url.searchParams.set(name, params.get(name));
          else url.searchParams.delete(name);
        }
        window.history.replaceState({}, '', url);
        if (variantChanged) {
          document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variantId: next.dataset.variantId, mediaId: next.dataset.mediaId } }));
        }
      } catch (error) {
        if (error.name !== 'AbortError') form.submit();
      }
    }
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.buttonPrice = this.querySelector('[data-button-price]');
      for (const button of this.querySelectorAll('[data-quantity-step]')) button.hidden = false;
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-quantity-step]');
        if (step && this.quantity) {
          this.quantity.value = Math.max(1, (Number(this.quantity.value) || 1) + Number(step.dataset.quantityStep));
          this.showTotal();
        }
      });
      this.quantity?.addEventListener('change', () => this.showTotal());
      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    // The button names the price of what it adds: the amount of one piece times the quantity.
    showTotal() {
      const price = this.buttonPrice?.querySelector('[data-price-live]');
      if (!price || !window.theme?.price) return;
      const count = Math.max(1, Math.floor(Number(this.quantity?.value) || 1));
      window.theme.price.update(price, { price: Number(this.buttonPrice.dataset.buttonPrice) * count, compareAtPrice: Number(this.buttonPrice.dataset.buttonCompare) * count });
    }

    async submit(event) {
      if (!window.theme) return;
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      const status = this.querySelector('[data-status]');
      const error = this.querySelector('[data-error]');
      status.replaceChildren();
      error.textContent = '';
      button.disabled = true;
      try {
        await window.theme.cart.add(new FormData(this.form));
        status.replaceChildren(this.querySelector('[data-added]').content.cloneNode(true));
      } catch (failure) {
        if (failure instanceof window.theme.CartError) error.textContent = failure.message || error.dataset.fallback;
        else HTMLFormElement.prototype.submit.call(this.form);
      } finally {
        button.disabled = false;
      }
    }
  }

  customElements.define('product-gallery', ProductGallery);
  customElements.define('variant-picker', class extends ProductChoice {});
  customElements.define('purchase-options', class extends ProductChoice {});
  customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();
})();
